import { Component } from '@angular/core';

@Component({
  selector: 'ntt-dropdown-menu-items',
  templateUrl: './dropdown-menu-items.html',
  styleUrl: './dropdown-menu-items.scss',
})
export class NttDropdownMenuItems {}
